import { render, staticRenderFns } from "./fingerprintVerification.vue?vue&type=template&id=81440c7a&scoped=true&"
import script from "./fingerprintVerification.vue?vue&type=script&lang=js&"
export * from "./fingerprintVerification.vue?vue&type=script&lang=js&"
import style0 from "./fingerprintVerification.vue?vue&type=style&index=0&id=81440c7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81440c7a",
  null
  
)

export default component.exports